

import React, { useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";
import "../styles/UtahAtAGlance.css";
import ScrambleText from "../utils/ScrambleText";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import "../hexagon.css";
import "../App.css";

const leftPanel = [
  
  {
    title: "Governor’s Corner",
    text: "A direct look at the Governor’s initiatives, vision, and statewide priorities shaping Utah’s future.",
    imagepath: "/img/glance-webp/utah_governor_img.webp",
    url: "/utah-at-a-glance/utah-governor",
    logo: "/img/governor/gov_logo.png",
  },
  {
    title: "Demographics",
    text: "Understand who lives in Utah—age groups, ethnicity, education, income, and population trends.",
    imagepath: "/img/glance-webp/demographics.webp",
    url: "/utah-at-a-glance/demographics ",
  },

  // {
  //   title: "Geographic Insights",
  //   text: "Explore physical and geographic features that shape Utah’s landscape—from mountain ranges to deserts.",
  //   imagepath: "/img/glance-webp/geoandinsights.jpg",
  //   url: " ",
  // },
  // {
  //   title: "Education and Intellectual Resources",
  //   text: "From primary schools to universities, examine educational access, performance, and resources across the state.",
  //   imagepath: "/img/glance-webp/education.jpg",
  //   url: " ",
  // },
  {
    title: "Employment in Utah",
    text: "Track Utah’s job sectors, workforce trends, income levels, and economic output.",
    imagepath: "/img/glance-webp/jobs.webp",
    url: "/utah-at-a-glance/jobs ",
  },
  // {
  //   title: "Energy Resources",
  //   text: "Explore Utah’s energy landscape including fossil fuels, renewables, and energy consumption data.",
  //   imagepath: "/img/glance-webp/eneryresource.jpg",
  //   url: " ",
  // },
  {
    title: "Housing in Utah",
    text: "Utah's housing market reflects rapid growth and high demand, driven by population increases, economic expansion, and a strong influx of new residents seeking vibrant communities and quality of life.",
    imagepath: "/img/glance-webp/housing.webp",
    url: "/utah-at-a-glance/utah-housing",
  },
  {
    title: "Utah Sports Club",
    text: "Highlighting major and minor league teams, college athletics, and community sports programs.",
    imagepath: "/img/glance-webp/sports.webp",
    url: "/utah-at-a-glance/sports",
  },
  // {
  //   title: "Tourism and Recreation",
  //   text: "Discover attractions, visitor data, and the impact of tourism on Utah’s economy.",
  //   imagepath: "/img/glance-webp/tourismglance.jpg",
  //   url: " ",
  // },
  {
    title: "Voters Count of Utah",
    text: "Engage with statistics on voting participation, registration, and electoral history.",
    imagepath: "/img/glance-webp/voterscount.webp",
    url: "/utah-at-a-glance/utah-voters-count",
  },
 
  {
    title: "Taxes",
    text: "Understand how Utah ranks in taxation, incentives, and economic competitiveness.",
    imagepath: "/img/glance-webp/taxes.webp",
    url: "/utah-at-a-glance/taxes ",
  },
  // {
  //   title: "Utah Culture",
  //   text: "Explore local arts, history, values, and traditions that shape Utah’s cultural identity.",
  //   imagepath: "/img/glance-webp/utahculture.webp",
  //   url: "/utah-at-a-glance/culture ",
  // },
  {
    title: "Utah Charging Stations",
    text: "Utah is building a strong EV charging network, with fast chargers and public stations expanding across cities and highways.",
    imagepath: "/img/glance-webp/charging-station.webp",
    url: "/utah-at-a-glance/charging-stations",
  },
  {
    title: "Utah Airports",
    text: "Utah’s airports, led by Salt Lake City International, provide vital air connectivity across the state and beyond.",
    imagepath: "/img/glance-webp/airport.webp",
    url: "/utah-at-a-glance/airports ",
  },
  // {
  //   title: "Utah Jobs",
  //   text: "Utah's job market is strong and diverse, driven by growth in tech, healthcare, and education sectors.",
  //   imagepath: "/img/glance-webp/jobs.jpg",
  //   url: "/jobs ",
  // },
  {
    title: "Utah Unemployment Rate",
    text: "Utah maintains one of the lowest unemployment rates in the nation, reflecting a resilient and stable economy.",
    imagepath: "/img/glance-webp/unemployment1.webp",
    url: "/utah-at-a-glance/unemployment-rate",
  },
  {
    title: "Utah Geothermal Hotspots",
    text: "Utah is rich in geothermal hotspots—particularly along the I‑15 corridor and in southwestern counties like Beaver—where underground heat fuels natural springs and geothermal power facilities.",
    imagepath: "/img/glance-webp/geo.webp",
    url: "/utah-at-a-glance/geothermal",
  },

  {
    title: "Utah MLM",
    text: "Utah is a major hub for multi-level marketing (MLM), home to several prominent MLM companies and a strong direct sales culture.",
    imagepath: "/img/glance-webp/mlm.webp",
    url: "/utah-at-a-glance/mlm",
  },
  {
    title: "Utah Hospitals",
    text: "Utah hospitals provide high-quality medical care across the state, serving both urban and rural communities with advanced healthcare services.",
    imagepath: "/img/glance-webp/hospital1.webp",
    url: "/utah-at-a-glance/hospitals",
  },
  {
    title: "Utah Counties",
    text: "Utah has 29 diverse counties ranging from urban Salt Lake County to rural San Juan County, each offering unique landscapes from mountain ranges to desert red rocks.",
    imagepath: "/img/glance-webp/geoandinsights.webp",
    url: "/utah-at-a-glance/utah-counties",
  },

  {
    title: "Utah Air Quality Index",
    text: "Utah’s air quality fluctuates seasonally, with inversions and wildfires impacting pollution levels. Alerts help residents take precautions when AQI is poor.",
    imagepath: "/img/glance-webp/traveller-with-beanie-relaxing-outdoors.webp",
    url: "/utah-at-a-glance/air-quality",
  },

  {
    title: "Utah Places to Visit",
    text: "Utah’s air quality fluctuates seasonally, with inversions and wildfires impacting pollution levels. Alerts help residents take precautions when AQI is poor.",
    imagepath: "/img/glance-webp/stone-gate-bryce-canyon-national-park.webp",
    url: "/utah-at-a-glance/places-to-visit",
  },

  {
    title: "Utah Federal Agencies",
    text: "Utah is home to various federal departments and agencies that support public services, defense, land management, and community development across the state.",
    imagepath: "/img/glance-webp/new-york-city-ellis-island-great-hall.webp",
    url: "/utah-at-a-glance/agencies",
  },

  {
    title: "Utah Zip Codes",
    text: " Utah ZIP codes organize the state’s regions for efficient mail delivery and reflect geographic and population distribution across counties and cities.",
    imagepath: "/img/glance-webp/close-up-magnifying-glass-map.webp",
    url: "/utah-at-a-glance/zipcodes",
  },

  // {
  //   title: "Utah Sports Club ",
  //   text: "Utah sports clubs foster community engagement and athletic excellence through diverse programs in soccer, basketball, football, and more across the state.",
  //   imagepath: "/img/glance-webp/black-man-doing-sports-playing-basketball-sunrise-silhouette.jpg",
  //   url: "/sports",
  // },

  {
    title: "Utah Adventure Activities",
    text: "Utah offers thrilling adventure sports like rock climbing, mountain biking, rafting, and skiing, set against its stunning natural landscapes.",
    imagepath: "/img/glance-webp/portrait-couple-horses.webp",
    url: "/utah-at-a-glance/adventure",
  },

  {
    title: "Utah Hill Airforce",
    text: "Hill Air Force Base in Utah is a major U.S. Air Force installation known for its critical role in aircraft maintenance, logistics, and national defense operations.",
    imagepath: "/img/glance-webp/f-16.avif",
    url: "/utah-at-a-glance/airforce",
  },

  {
    title: "Finance",
    text: "Review personal finance trends, average incomes, economic stability, and financial health.",
    imagepath: "/img/glance-webp/finance3.webp",
    url: "/utah-at-a-glance/finance",
  },

  {
    title: "Utah Cities",
    text: "Discover vibrant opportunities and connections across all major Utah cities",
    imagepath: "/img/glance-webp/cities.webp",
    url: "/utah-at-a-glance/utah-cities",
  },
  {
    title: "Education and Intellectual Resources",
    text: "Discover vibrant opportunities and connections across all major Utah cities",
    imagepath: "/img/glance-webp/eduandresource.webp",
    url: "/utah-at-a-glance/education-and-intellectual-resources",
  },
  {
    title: "Utah Mines",
    text: "Uncover the industrial heart of Utah with a detailed look at its major mines",
    imagepath: "/img/glance-webp/mines.webp",
    url: "/utah-at-a-glance/utah-mines",
  },
  {
    title: "Utah Research Centers and Institutes",
    text: "Research Centers and Institutes: Advancing Innovation Across Utah",
    imagepath: "/img/glance-webp/research.webp",
    url: "/utah-at-a-glance/utah-research",
  },
  {
    title: "Utah Libraries",
    text: "Utah boasts a robust network of libraries",
    imagepath: "/img/glance-webp/interior.webp",
    url: "/utah-at-a-glance/utah-libraries",
  },
];





const buttonLabels = [
   { label: "", title: "" , bgColor:"#3a3aab"},
   { label: "", title: "" , bgColor:"#3a3aab"},
  { label: "Governor’s Corner", title: "Governor’s Corner" , bgColor:"#3a3aab"},
  { label: "Adventure Activities", title: "Utah Adventure Activities" , bgColor:"#d134c5" },
  { label: "Air Quality Index", title: "Utah Air Quality Index"  , bgColor:"#619e61"},
  { label: "Airports", title: "Utah Airports"  , bgColor:"#ebd34d"},
  { label: "Charging Stations", title: "Utah Charging Stations"  , bgColor:"#ee7137"},
  { label: "Cities", title: "Utah Cities"  , bgColor:"#3a3aab"},
  { label: "Counties", title: "Utah Counties" , bgColor:"#619e61" },
  { label: "", title: "" , bgColor:"#3a3aab"},
  { label: "", title: "" , bgColor:"#3a3aab"},
  
  
  { label: "Culture", title: "Utah Culture"  , bgColor:"#ee7137"},
  { label: "Demographics", title: "Demographics"  , bgColor:"#619e61"},
  { label: "Education and Intellectual Resources", title: "Education and Intellectual Resources"  , bgColor:"#d134c5"},
  { label: "Employments", title: "Employment in Utah"  , bgColor:"#3a3aab"},
  { label: "Federal Agencies", title: "Utah Federal Agencies" , bgColor:"#d134c5" },
  { label: "Finance", title: "Finance"  , bgColor:"#ee7137"},
  { label: "Geothermal Hotspots", title: "Utah Geothermal Hotspots"  , bgColor:"#ebd34d"},
  { label: "Hill Airforce", title: "Utah Hill Airforce"  , bgColor:"#ebd34d"},
  { label: "Hospitals", title: "Utah Hospitals"  , bgColor:"#d134c5"},
  { label: "Housing", title: "Housing in Utah" , bgColor:"#619e61" },
  { label: "Libraries", title: "Utah Libraries"  , bgColor:"#ee7137"},
  { label: "MLM", title: "Utah MLM"  , bgColor:"#ebd34d"},
  { label: "Mines", title: "Utah Mines"  , bgColor:"#3a3aab"},
  { label: "Places to Visit", title: "Utah Places to Visit"  , bgColor:"#d134c5"},
  { label: "Research Centers and Institutes", title: "Utah Research Centers and Institutes"  , bgColor:"#3a3aab"},
  { label: "", title: "" , bgColor:"#3a3aab"},
  { label: "", title: "" , bgColor:"#3a3aab"},
  
    
  { label: "Sports Club", title: "Utah Sports Club" , bgColor:"#619e61" },
  { label: "Taxes", title: "Taxes" , bgColor:"#ebd34d" },
  { label: "Unemployment Rate", title: "Utah Unemployment Rate"  , bgColor:"#d134c5"},
  { label: "Voters Count", title: "Voters Count of Utah"  , bgColor:"#ee7137"},
  { label: "Zip Codes", title: "Utah Zip Codes"  , bgColor:"#619e61"},
  { label: "Show All", title: "" , bgColor:"#3a3aab" },
  { label: "", title: "" , bgColor:"#3a3aab"},
  { label: "", title: "" , bgColor:"#3a3aab"},
  
];




const generateHexRows = () => {
  const width = window.innerWidth;
  const rows = [];

  if (width <= 600) {
    // 🔹 Mobile: alternate 3 and 2 items per row
    for (let i = 0, toggle = true; i < buttonLabels.length;) {
      const count = toggle ? 3 : 2;
      rows.push(buttonLabels.slice(i, i + count));
      i += count;
      toggle = !toggle;
    }
  } else if (width > 600 && width < 1030) {
    // 🔹 Tablet: 5 items per row
    for (let i = 0; i < buttonLabels.length; i += 5) {
      rows.push(buttonLabels.slice(i, i + 5));
    }
  } else {
    // 🔹 Desktop: 7 items per row
    for (let i = 0; i < buttonLabels.length; i += 9) {
      rows.push(buttonLabels.slice(i, i + 9));
    }
  }

  return rows;
};


const hexRows = generateHexRows();




const UtahAtAGlanceDraft = () => {
  const [selectedTitle, setSelectedTitle] = useState(null);
  const filteredCards = selectedTitle ? leftPanel.filter((item) =>(item.title===selectedTitle)):leftPanel
  const [activeTab, setActiveTab] = useState(""); 

  return (
    <div>
      <LandingSection
        data={{ imageName: "login.webp", title: "Utah At a Glance" }}
      />
      <div className="utah-at-a-glance-section">
        <div className="utah-at-a-glance-intro">
          <div className="utah-at-a-glance-intro-sec1">
            <h2>
              One State. Many Stories. Dive into the data that defines Utah.
            </h2>
          </div>
          <div className="utah-at-a-glance-intro-sec2">
            <p>
              Explore the heart of Utah—its people, places, economy, and
              culture. From county-level insights to infrastructure and
              lifestyle, this is your one-stop overview of what defines the
              Beehive State.
            </p>
          </div>
        </div>
      </div>

     





<div className="hex-grid">
  {hexRows.map((row, index) => (
    <div key={index} className={`hex-row ${index % 2 !== 0 ? 'offset' : ''}`}>
      {row.map(({ label, title , bgColor}, i) => (
        <div key={i} className="hex-border">
          <div className="hex-wrapper">
          <div className="hex-inner"
           style={{ backgroundColor: bgColor || "#3a3aab" }} >
           <div className="upperHexa">
            <div
              className={`hexagon ${activeTab === title ? 'active' : ''} `}
              onClick={() => {
                setActiveTab(title);
                setSelectedTitle(title);
              }}
              style={{color:bgColor}}
            >
              {label}
            </div>
            </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  ))}
</div>


  

      <div
  className={`${
    filteredCards.length === 1
      ? "flex justify-center items-center lg:w-[70vw] w-full"
      : "grid-panel"
  } mx-auto`}
>
     
        {filteredCards.map((item, index) => (
          <div
            className="grid-item flex justify-center items-center mx-auto  w-full"
            key={index}          
            style={{ backgroundImage: `url(${item.imagepath})`}}
          >
            <div className="grid-overlay-shield">
              <div className="grid-overlay">
                <div>{item.logo ? <img src={item.logo} alt="logo" /> : ""}</div>
                <div className="grid-text">
                  <h2>{item.title}</h2>
                  <p>{item.text}</p>
                  <div className="button-outer">
                    <span className="corner top-left" />
                    <span className="corner top-right" />
                    <span className="corner bottom-left" />
                    <span className="corner bottom-right" />
                    <Link to={item.url}>
                      <button className="glance-action-button">
                        <span className="text">
                          <ScrambleText text="Explore More" />
                        </span>

                        <ArrowUpRight
                          className="icon"
                          size={16}
                          strokeWidth={2}
                        />
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <section className="why-section">
        <div className="fit-text-container">
          <h1 className="background-title">SHAPING TOMORROW, TOGETHER</h1>
        </div>

        <h2 className="section-heading">What's Next for Utah?</h2>

        <p className="section-description">
        Utah is moving forward with bold ideas—smart cities, clean energy, and inclusive growth powered by data.
If you're passionate about shaping the future or want to collaborate, reach out to us and be part of the journey.
Let’s build a stronger, smarter Utah together.
        </p>
        <div style={{ margin: "40px 0" }}>
          <ActionButton data="Contact Us" link="/contact-us" />
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default UtahAtAGlanceDraft;
